import { useEffect } from "react";

const LogOut = () => {
    useEffect(() => {
        localStorage.clear();
        sessionStorage.clear();
        globalThis.location.href = process.env.REACT_APP_PINGONE_LOGOUT_URL;
    }, []);
    return null;
}

export default LogOut